import { buildLink, KitchenSinkRoute, RouteSlotInput } from '@luks/ui';

import {
  useListingEventsEmbedByDepartmentQuery,
  useListingEventsEmbedByTypeAndDepartmentQuery,
  useListingEventsEmbedQuery,
} from '../../../generated/queries';
import { isDefined } from '../../commons/is-defined';
import { buildDrupalImage } from '../Image';

export const mapEventsEmbed =
  (kind: 'byType' | 'byDepartment' | 'byTypeAndDepartment') =>
  (
    input:
      | ParagraphListingEventsEmbedFragment
      | ParagraphListingEventsEmbedByDepartmentFragment
      | ParagraphListingEventsEmbedByTypeAndDepartmentFragment,
  ): RouteSlotInput<typeof KitchenSinkRoute, 'body', 'EventView'> => ({
    key: 'EventView',
    input: function useListingEventsEmbed() {
      const queries = {
        byType: useListingEventsEmbedQuery,
        byDepartment: useListingEventsEmbedByDepartmentQuery,
        byTypeAndDepartment: useListingEventsEmbedByTypeAndDepartmentQuery,
      };
      const { data, isLoading, isFetching } = queries[kind]({
        argument: input.argument || '',
        offset: 0,
        // Fetch 4 items just to learn if there are more than 3 available.
        limit: 4,
      });
      const items = data?.listingEventsEmbed.items.filter(isDefined) || [];
      const shouldDisplayCta = items.length === 4;
      // Display only 3 items.
      items.splice(3);
      return [
        {
          title: input.title,
          events:
            items.map((item) => ({
              Link: buildLink({ href: item.path }),
              Image: buildDrupalImage(item.image, 'teaser'),
              title: item.title,
              location: item.location,
              startDate: item.startDate,
              endDate: item.endDate,
              startTime: item.startTime,
              endTime: item.endTime,
              eventStatus: item.eventStatus,
            })) || [],
          LinkCta: shouldDisplayCta
            ? buildLink({ href: input.cta.url })
            : undefined,
        },
        isLoading || isFetching ? 102 : items.length > 0 ? 200 : 404,
      ];
    },
  });
